module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Money-c39518242bc180af679898edfd68fdbc.svg";